export const PROCEDURES_TABLE_COLUMNS = [
  { key: 'category', label: 'Category', sortable: true },
  { key: 'noOfProcedures', label: 'No. of procedures', sortable: true },
  { key: 'production', label: 'Production', sortable: true },
  { key: 'avgPerProcedure', label: 'Avg. per procedure', sortable: true },
] as const
